<dialog qai-dialog #dialog [heading]="details()?.title ?? ''" (afterClose)="handleAfterClose()">
  @if (loading()) {
    <div class="state-message">
      <qai-loading size="medium" />
    </div>
  } @else if (loadError()) {
    <div class="state-message">
      {{ 'simulationBuilder.CALL_DETAILS_LOAD_ERROR' | transloco }}
    </div>
  } @else if (details()) {
    <div class="generated-call-details-container">
      <generated-call-details
        [contentMarkdown]="details()!.contentMarkdown"
        [contentMaxHeight]="contentMaxHeight()"
        [refinementStatus]="refinementStatus()"
        [isContentRefreshing]="isContentRefreshing()"
        [isRefinementBlocked]="isRefinementBlocked()"
        (requestChangesSubmitted)="handleRequestChangesSubmitted($event)"
        (errorDismissed)="handleDismissRefinementError()"
      ></generated-call-details>
    </div>
  }

  <div class="action-button-container">
    <button
      qai-button
      kind="primary"
      size="large"
      [disabled]="loading() || loadError()"
      (click)="handleSelectAvatarClick()"
    >
      {{ 'simulationBuilder.SELECT_AVATAR_BUTTON' | transloco }}
    </button>
  </div>
</dialog>
